








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// getAllUserWithRole
// GETALLUSERWITHROLE
const GETALLUSERWITHROLE= createAsyncThunk(
  "getAllUserWithRole/getAllUserWithRole",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllUserWithRoleSlice = createSlice({
  name: "getAllUserWithRoleSlice",
  initialState: {
    getAllUserWithRole: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllUserWithRole: (state) => {
        state.getAllUserWithRole.loading = false
        state.getAllUserWithRole.error = false
        state.getAllUserWithRole.data = []
        state.getAllUserWithRole.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLUSERWITHROLE.fulfilled, (state, action) => {
      state.getAllUserWithRole = {
        ...state.getAllUserWithRole,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLUSERWITHROLE.pending, (state, action) => {
      state.getAllUserWithRole = {
        ...state.getAllUserWithRole,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLUSERWITHROLE.rejected, (state, action) => {
      state.getAllUserWithRole = {
        ...state.getAllUserWithRole,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllUserWithRoleAction = {
    GETALLUSERWITHROLE,
};

export { getAllUserWithRoleAction };
export default getAllUserWithRoleSlice.reducer;
export const {setInitialStateOfgetAllUserWithRole} = getAllUserWithRoleSlice.actions
